// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3f5fG","info":"PatientInfo_info__2nGKT"};